/**
 * Shared browser storage initialization used by index.jsx and StandaloneNavigation render.js.
 * Extracted for testability.
 */
import { isIsolatedCloud } from '@atlaskit/atlassian-context/is-isolated-cloud';

import { initializeBrowserStorageControls } from '@confluence/browser-storage-controls/entry-points/initializeBrowserStorageControls.ts';

/**
 * In Isolated Cloud (IC), ConsentHub is unavailable and consent is stored in the legacy
 * atl-gdpr-consent cookie. Pre-populate window.__COOKIE_CONSENT_PREFERENCES__ synchronously
 * from that cookie so that useCookiesConsentBanner can determine the correct initial banner
 * visibility without waiting for browser-storage-controls to initialize asynchronously,
 * preventing a banner flash on page load.
 */
function preloadICCookieConsent() {
	if (isIsolatedCloud()) {
		const gdprCookie = document.cookie
			.split('; ')
			.find((row) => row.startsWith('atl-gdpr-consent='))
			?.split('=')[1];

		if (gdprCookie) {
			window.__COOKIE_CONSENT_PREFERENCES__ = { consentToken: gdprCookie };
		}
	}
}

/**
 * Initialize browser storage controls.
 * Must be called after Statsig is ready and before initializeStorageManager.
 *
 * @param {{ userId?: string, cloudId?: string }} context
 */
export async function initializeBootstrapStorage({ userId, cloudId }) {
	preloadICCookieConsent();
	await initializeBrowserStorageControls({ userId, cloudId });
}
